var map = {
	"./_dummy.jpg": 35,
	"./a.rösti.jpg": 81,
	"./adolfogi.jpg": 82,
	"./baume-schneider.jpg": 83,
	"./beatjans.jpg": 84,
	"./cassis.jpg": 85,
	"./infantino.jpg": 86,
	"./kks.jpg": 87,
	"./korps-kdtsüssli(kks).jpg": 88,
	"./martinpfister.jpg": 89,
	"./martullo-blocher.jpg": 90,
	"./mathias.jpg": 91,
	"./mirjam.jpg": 92,
	"./nina.jpg": 93,
	"./parmelin.jpg": 94,
	"./ritter.jpg": 95,
	"./samuelschmid.jpg": 96,
	"./seppblatter.jpg": 97,
	"./uelimaurer.jpg": 98,
	"./violaamherd.jpg": 99
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;